module.exports = {
  title: "AquaGIS",
  domain: "localhost:8000",
  apiBaseURL: process.env.VUE_APP_BASE_URL,
  valvesBaseURL: process.env.VUE_APP_VALVES_URL,
  keycloakURL: process.env.VUE_APP_KEYCLOAK_URL,
  version: 'v42 - 2023-11-06',
  requestTimeout: 10, // in minutes
  removeTokenAfterBrowserClose: false,
}
